import React from 'react';
import './index.scss';

class CardTitle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    const { title, subTitle } = this.props;

    return (
			<div className="cardTitle">
				<div className="title">
					<div className="desc">{title}</div>
					<div className="tip">
						<span className="lineLeft"></span>
						{subTitle}
						<span className="lineRight"></span>
					</div>
				</div>
			</div>
    );
  }
}

export default CardTitle;
